<script>
import appConfig from "@/app.config";
import BellRing from '@/components/bell-ring'
import Vue from 'vue'
import { EventBus } from '@/eventBus';
import { notificationMethods } from "@/state/helpers";
import { connectSocket } from '@/state/socket.js';
import { apiService } from '@/helpers/api.service';


export default {
  components: { BellRing },
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  computed: {
    newOrders() {
      return this.$store.getters.newOrders;
    },
  },
  data() {
    return {
      intervalId: null,
      newOrdersSocket: []
    };
  },
  mounted() {
    this.getWebSocket(),
      Vue.notification.requestPermission()
    EventBus.$on('stop-sound', this.stopPlayingSound);
    // document.querySelector("html").setAttribute('dir', 'rtl')
  },
  beforeDestroy() {
    EventBus.$off('stop-sound', this.stopPlayingSound);
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
    newOrders(newOrders) {
      if (newOrders.length > 0) {
        this.notifyNewOrder(newOrders[newOrders.length - 1])
      }
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
    notifyNewOrder(newOrder) {
      this.$notification.show('Welly GO', {
        body: 'NUEVO PEDIDO ' + newOrder.code + '!',
        icon: 'https://www.wellygo.app/assets/images/wellyLogo.svg',
      }, {})
    },

    async getWebSocket() {
      let socket = await connectSocket()

      socket.on("newOrder", (res) => {
        let newOrdersSocket = res;
        if (newOrdersSocket && newOrdersSocket._id) {
          const checkOrderNew = this.newOrdersSocket.findIndex(x => x._id === newOrdersSocket._id);
          if (checkOrderNew === -1) {
            newOrdersSocket.isNew = true;
            this.newOrdersSocket.push(newOrdersSocket);
            this.startPlayingSound()
          }
        }
      });
      socket.on("userCanceled", (res) => {
        const removeIndex = this.newOrdersSocket.findIndex(item => item._id === res._id);
        if (removeIndex !== -1) {
          this.newOrdersSocket.splice(removeIndex, 1);
        }

        if (this.newOrdersSocket.length === 0) {
          this.stopPlayingSound()
        }
      });
    },

    async getOrders() {
      try {
        const res = await apiService.getOrders();

        if (res && res.length > 0) {
          this.newOrdersSocket = res.filter(order => order.status?.code === "new");
        } else {
          this.newOrdersSocket = [];
        }
      } catch (error) {
        console.error(error);
      }
    },
    startPlayingSound() {
      if (this.newOrdersSocket.length > 0) {
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
        this.$refs.bellRing.playSound();

        this.intervalId = setInterval(async () => {
          await this.getOrders()

          if (this.newOrdersSocket.length > 0) {
            this.$refs.bellRing.playSound();
          } else {
            this.stopPlayingSound();
          }
        }, 30000);
      }
    },
    stopPlayingSound() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  },
};
</script>

<template>
  <div id="app">
    <BellRing ref="bellRing" />
    <RouterView />
  </div>
</template>
